import { Alert, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import Role from "../enum/Role.enum";
import { getAccountOpeningLink } from "../utils/accountActivation";

const AccountActivationBanner = () => {
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.user.user);
  const roles = useSelector((state: RootState) => state.user.roles);
  const provider = useSelector((state: RootState) => state.app.provider);

  if (!user || roles.includes(Role.AGENT_ADMIN) || user.has_open_account) {
    return null;
  }

  const accountOpeningLink = getAccountOpeningLink(provider);

  return (
    <Alert
      severity="warning"
      sx={{ mb: 3, alignItems: "center" }}
      action={
        accountOpeningLink ? (
          <Button
            color="inherit"
            size="small"
            href={accountOpeningLink}
            target="_blank"
            rel="noreferrer"
          >
            {t("accountActivation.openAccount")}
          </Button>
        ) : undefined
      }
    >
      <Box>{t("accountActivation.message")}</Box>
    </Alert>
  );
};

export default AccountActivationBanner;
